var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5969 11.9985C15.5969 13.9051 13.9836 15.4507 11.9935 15.4507C10.0034 15.4507 8.39012 13.9051 8.39012 11.9985C8.39012 10.0919 10.0034 8.54626 11.9935 8.54626C13.9836 8.54624 15.5969 10.0919 15.5969 11.9985ZM12 4.81042C9.9395 4.81956 7.80372 5.32118 5.78192 6.28156C4.28076 7.024 2.8178 8.07148 1.54788 9.36438C0.92416 10.0244 0.12862 10.98 0 11.9996C0.0152 12.8828 0.9626 13.973 1.54788 14.6349C2.73874 15.877 4.1636 16.8952 5.78192 17.7185C7.66734 18.6335 9.75424 19.1603 12 19.1896C14.0625 19.1803 16.1978 18.6729 18.2173 17.7185C19.7185 16.976 21.1822 15.9278 22.4521 14.6349C23.0758 13.9749 23.8714 13.0192 24 11.9996C23.9848 11.1164 23.0374 10.0262 22.4521 9.36435C21.2613 8.12223 19.8356 7.10476 18.2173 6.28152C16.3329 5.3672 14.2408 4.844 12 4.81042ZM11.9985 6.59539C15.1209 6.59539 17.652 9.01526 17.652 12.0004C17.652 14.9855 15.1209 17.4054 11.9985 17.4054C8.8761 17.4054 6.34498 14.9855 6.34498 12.0004C6.34498 9.01526 8.8761 6.59539 11.9985 6.59539Z",
    fill: "#14086D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/EyeOpen.ce62058cbc24c49f00e185c9b5614b2d.svg";
export { ForwardRef as ReactComponent };